import styled from 'styled-components';

export const Title = styled.h3`
    font-family: 'Alliance No.1';
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 30px;
    letter-spacing: -0.05em;
    color: ${({ theme }) => theme.shades.white[100]};
    margin: 0;
    display: flex;
    align-items: center;
    margin: 0 0;
    white-space: nowrap;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        margin: 30px 0;
        font-size: 30px;
    }
`;

export const NftCount = styled.span`
    font-size: 16px;
    line-height: 30px;
    font-weight: 400;
    font-family: 'Alliance No.1';
    font-style: normal;
    letter-spacing: -0.05em;
    color: ${({ theme }) => theme.shades.white[40]};
    margin-left: 6px;
`;
